import React from 'react';
import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import ConsultantScreen from '../components/screens/consultants/ConsultantScreen';

export default function Consultants(props) {
  return (
    <Layout headerTitle="Consultants">
      <PageContainer id="consultants">
        <ConsultantScreen props={props} />
      </PageContainer>
    </Layout>
  );
}
